import { Client } from 'botpress-client'
import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '../../client'
import { useQueryKeys } from '../useQueryKeys'

type GetBotWebchatTypeEnum = Parameters<Client['getBotWebchat']>[0]['type']

export function useBotWebchat({
  botId,
  workspaceId,
  type,
}: {
  botId?: string
  workspaceId?: string
  type: GetBotWebchatTypeEnum
}) {
  const { getBotWebchat } = useQueryKeys()

  return useQuery({
    //TODO: set a cache duration, currently not cached to be safe
    enabled: !!botId && !!workspaceId,
    queryKey: getBotWebchat(botId),
    queryFn: async () => {
      if (!botId) {
        throw new Error('No BotId provided')
      }

      if (!workspaceId) {
        throw new Error('No workspaceId provided')
      }
      const { code } = await getApiClient(workspaceId).getBotWebchat({ id: botId, type })
      return code
    },
    meta: {
      errorMessage: 'Failed to fetch webchat script, please try again later',
    },
  })
}
